import React from 'react'
import { Link } from 'react-router-dom';

function Feature() {
    const gototop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }
    return (
        <>
            <section>
                <div className="container">
                    <div
                        className="row justify-content-between align-items-center mb-4 mb-lg-5"
                    >
                        <div className="col-lg-12 col-md-12 text-center">
                            <div>
                                <h2>
                                    How Online Vehicle Inspections Work
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 text-center">
                            Complete your inspection from your phone in three simple steps.
                        </div>
                        {/* <div className="col-lg-4 col-12 text-center">              
              <Link className="btn btn-dark" to="quotation">Order Your Inspection</Link>
            </div> */}
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                            <div className="p-5 rounded active position-relative" style={{ boxShadow: "0 10px 30px 5px rgba(1, 164, 121, 0.06)" }}>
                                <div className="f-icon">
                                    <i className="las la-calendar"></i>
                                </div>
                                <h5 className="mt-4 mb-3">Book Your Inspection</h5>
                                <p className="mb-0">
                                    Choose the inspection you need, enter your vehicle information, and schedule your inspection online.
                                  
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                            <div className="p-5 rounded active position-relative" style={{ boxShadow: "0 10px 30px 5px rgba(1, 164, 121, 0.06)" }}>
                                <div className="f-icon">
                                      <i className="las la-video"></i>
                                </div>
                                <h5 className="mt-4 mb-3">Join Your Live Video Inspection</h5>
                                <p className="mb-0">
                                    Connect with your inspector through a live video call and follow their guidance as you walk through the required inspection
                                    points on your vehicle.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                            <div className="p-5 rounded active position-relative" style={{ boxShadow: "0 10px 30px 5px rgba(1, 164, 121, 0.06)" }}>
                                <div className="f-icon">
                                      <i className="las la-file-alt"></i>
                                </div>
                                <h5 className="mt-4 mb-3">Receive Your Your Inspection Form</h5>
                                <p className="mb-0">
                                    Once the inspection is complete, your inspection form will be reviewed and sent directly to your email.
                                </p>
                            </div>
                        </div>



                    </div>
                    {/* <div className="row">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-12 col-md-12 mb-lg-0">
                                <p className="lead mb-0">
                                </p>
                                <p className='mt-4'><Link className="btn btn-dark " to="quotation">Order Your Inspection</Link></p>
                                <p className='mt-4'><Link className="btn btn-dark " to="quotation">Book Your Inspection</Link></p>
                            </div>
                        </div>
                    </div> */}
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-12">
                            <div className="mb-5">
                                <p className="lead mb-0">
                                </p>
                                <p className='mt-4'><Link className="btn btn-dark " to="quotation">Book Your Inspection</Link></p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Feature
